/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	InvoiceEmailSettingsUpdatePathParams,
	InvoiceEmailSettingsUpdateRequest,
	InvoiceEmailSettingsUpdateResponse,
} from '../types/InvoiceEmailSettingsUpdate'

/**
 * PUT /:organisation/invoice-email-settings
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoiceEmailSettingsController.php InvoiceEmailSettingsController::update
 */
export async function invoiceEmailSettingsUpdate(
	organisation: InvoiceEmailSettingsUpdatePathParams['organisation'],
	data: InvoiceEmailSettingsUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoiceEmailSettingsUpdateResponse>> {
	return axiosInstance.put(`/${organisation}/invoice-email-settings`, data, config)
}
